import React from "react";
import ImageQueHablamos from "../../images/modulo14/quehablamoslosperuanosconclusion.png";
import LayoutActividad from "../../components/LayoutActividad";

import { modulo14 } from "../../routes/Module14";
import Sidebar from "./Sidebar";
import GuiaDocente from "../../components/GuiaDocente";

const QueHablamos = () => {
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `Cierre`,
      url: "cierre",
    },
  ];
  const pages = {
    titlePrev: `${modulo14.content[2].name} - ${modulo14.content[2].activities[10].name}`,
    linkPrev: `/${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[10].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h1 className="my-5">Entonces, ¿qué hablamos los peruanos?</h1>
      <div className="header-img">
        <img
          src={ImageQueHablamos}
          className="card-img-top full-width"
          alt="..."
        />
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que observen con detenimiento la imagen presentada. Dé tiempo
            suficiente para que lean los diálogos y puedan reconocer los
            detalles que ofrece la ilustración. Otorgue los roles de los
            personajes y pídales que lean los diálogos en voz alta. Elabore
            algunas preguntas:
          </li>
          <li>
            - “¿En dónde se encuentran los personajes? (Posible respuesta: En
            una plaza). - ¿Cuál es el problema que plantea Olga? (Posible
            respuesta: Su familia viene de Huancavelica a realizar unos trámites
            y no hablan mucho castellano). - De manera general: ¿Qué le
            responden los demás personajes? (Posible respuesta: La mayoría
            comentan que la situación para los que no hablan castellano ha
            mejorado. Señalan que hay intérpretes, textos y en general algunos
            servicios en quechua)”.
          </li>
          <li>
            Señale que a lo largo de la unidad se ha trabajado la convivencia,
            la deliberación y la participación. Resalte qué contenidos hemos
            visto que podamos vincular a esas capacidades. Por ejemplo:
            <ul>
              <li>
                <i>
                  “Hemos visto que el Perú es un país multilingüe. El
                  reconocimiento de la diversidad de lenguas existentes en
                  nuestro país resulta fundamental. Pero no basta con reconocer
                  su existencia, es importante que se reconozca a las personas
                  que hablan lenguas originarias como iguales, como ciudadanos
                  con deberes y derechos, sin discriminarlas, considerando que
                  ningún idioma o variedad de castellano es inferior a otro.
                  Para ello, el Estado debe garantizar que ciertos servicios
                  básicos se ofrezcan en lenguas originarias. Conocer y valorar
                  la diversidad lingüística de nuestro país nos ayuda a la
                  convivencia entre peruanos. Ante los retos y problemas que
                  significan la diversidad de lenguas, es importante deliberar,
                  es decir, tener una conversación en la que se escuchen
                  distintos puntos de vista sobre las soluciones y las maneras
                  que existen para promover la valoración de las diferentes
                  lenguas. Es esencial no aceptar ningún tipo de discriminación
                  sobre cómo se habla el castellano. Para ello, el niño o la
                  niña debe participar rechazando la exclusión de ciertos grupos
                  que hablan una variedad distinta a la del castellano
                  estándar”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Ahora retome la pregunta principal: Entonces, ¿qué hablamos los
            peruanos? Para responderla, guíe al niño o a la niña en la
            discusión:
            <i>
              ¿Cuántas lenguas hablamos? ¿Qué significa “variedades del
              castellano”? ¿Por qué existe la discriminación lingüística?
            </i>
          </li>
          <li>
            Cierre la sesión resaltando nuevamente que en el mundo existen
            muchos hablantes de castellano, cada uno lo habla de manera
            distinta, con sus particularidades. El castellano no es uno solo. En
            el Perú, se hablan distintas variedades de castellano, ninguna es
            superior o inferior, solo son distintas. Comprender esto nos ayudará
            a que no existan actos de discriminación y a colaborar a la
            convivencia ente peruanos.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default QueHablamos;
